import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { toggleTaskSelection } from 'bundles/apex/deals/show/store/planner_bulk_actions/actions';

import pluralize from 'pluralize';

import { Button } from 'components/ui/button';
import Modal from 'components/modal';

export function DeleteModal({ apexAdmin, selection, show, tasks, toggleTaskSelection, onClose, onDelete }) {
  const undeletableTasks = tasks.filter((task) => {
    return selection[task.id] && task.required && !apexAdmin;
  });

  const deleteableTaskCount = Object.keys(selection).length - undeletableTasks.length;
  const deleteTasks = async () => {
    const message = 
      `${deleteableTaskCount} ${pluralize('task', deleteableTaskCount)}` +
      ` ${pluralize('has', deleteableTaskCount)} been deleted!`;

    undeletableTasks.forEach(task => toggleTaskSelection(task));
    await onDelete(message);
    onClose();
  };

  let deleteMessage;
  if (deleteableTaskCount === 0) {
    deleteMessage = <p>All of the selected tasks are required and cannot be deleted.</p>;
  } else if (undeletableTasks.length === 0) {
    deleteMessage = (
      <p>
        Are you sure you want to delete <b>{deleteableTaskCount}</b> {pluralize('task', deleteableTaskCount)}?
      </p>
    );
  } else {
    deleteMessage = (
      <React.Fragment>
        <p>
          <strong>{undeletableTasks.length}</strong> required
          {' ' + pluralize('task', undeletableTasks.length)} cannot be deleted.
        </p>
        <p>
          Are you sure you want to delete the
          remaining <strong>{deleteableTaskCount}</strong> {pluralize('task', deleteableTaskCount)}?
        </p>
      </React.Fragment>
    );
  }
  
  return (
    <Modal
      show={show}
      onHide={onClose}
    >
      <Modal.Header closeButton>Delete Tasks</Modal.Header>

      <Modal.Body>
        {deleteMessage}
      </Modal.Body>

      <Modal.Footer>
        <Button label={deleteableTaskCount === 0 ? 'Close' : 'Cancel'} variant="outline" onClick={onClose} />
        {deleteableTaskCount > 0 && <Button label="Yes, Delete" variant="destructive" onClick={deleteTasks} />}
      </Modal.Footer>
    </Modal>
  );
}

DeleteModal.propTypes = {
  apexAdmin: PropTypes.bool.isRequired,
  selection: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  tasks: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    required: PropTypes.bool.isRequired,
  })),
  toggleTaskSelection: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  apexAdmin: state.forUser.apexAdmin,
  selection: state.plannerBulkActions.selection,
  tasks: state.tasks,
});

const mapDispatchToProps = {
  toggleTaskSelection,
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteModal);
